import Route from '@ember/routing/route';

export default class EngagementRoute extends Route {}
